/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../controls.module.ts" />
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>


module Meevo.Components.Controls {

    import Dictionary = _.Dictionary;
    import IReportControlCriteria = Meevo.Plugins.Reports.IReportControlCriteria;
    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;

    export class De110Criteria implements IReportControlCriteria {

        public criteria: Dictionary<any>;

        constructor(private scope: IReportControlScope) {
            this.criteria = {
                EmployeeEntityTypeEnum: null
            };

            scope.$watch(
                () => scope.mainModel['SortReportByDE110'],
                _.debounce(this.updateCriteria.bind(this), 200),
                true
            );
        }

        private updateCriteria(newValue: string, oldValue: string) {
            if (newValue === oldValue) return;

            angular.extend(this.criteria, {
                EmployeeEntityTypeEnum: this.scope.mainModel['SortReportByDE110']
            });

            this.scope.$apply();
        }
    }

}
